import React, { useState, useRef, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { 
    Flex, Heading, Input, Button, ButtonGroup, Text, CircularProgress, CircularProgressLabel,
    InputGroup, InputLeftElement, InputRightElement, Icon, IconButton, Select,
    Stack, HStack, Image, Wrap, WrapItem, Center, InputRightAddon,
    Tabs, Tab, TabList, TabPanels, TabPanel,
    Table, Thead, Tbody, Tfoot, Tr, Th, Td, TableCaption, TableContainer, useDisclosure, useToast,
    VStack
} from '@chakra-ui/react';
import ReactPaginate from 'react-paginate';
import { MdSettings, MdAdd, MdAddCircleOutline, MdCalendarToday, MdSearch, MdEdit, MdDeleteForever, MdSave } from 'react-icons/md';
import { BsArrowLeftCircle, BsArrowRightCircle } from 'react-icons/bs';
import { useNavigate, useLocation } from 'react-router-dom';
import { FormattedDate, FormattedTime } from 'react-intl';
import { MultiSelect } from "react-multi-select-component";
import { sleep, confirmChoice } from "../../utils/helpers"
import Users from '../Users';
import httpClient from '../../services/http-client';

const SORT_BY_LIST = [
    { title: "Theo thời gian", value: "id" },
    { title: "Theo họ tên", value: "full_name" },
];

const SORT_DIR_LIST = [
    { title: "Giảm dần", value: "desc" },
    { title: "Tăng dần", value: "asc" }, 
];

function Admin() {
    const [ cookies, setCookie, removeCookie ] = useCookies(["loginCookie"]);
    const [isAllowAccessThisPage, setIsAllowAccessThisPage] = useState(true);
    const initialRef = useRef(null);
    const toast = useToast();
    const navigate = useNavigate();
    const { search } = useLocation();
    const [limit, setLimit] = useState(25);
    const [order_by, setOrderBy] = useState(SORT_BY_LIST[0]["value"]);
    const [order_dir, setOrderDir] = useState(SORT_DIR_LIST[0]["value"]);
    const [searchText, setSearchText] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [initDatas, setInitDatas] = useState({});
    const [settingDatas, setSettingDatas] = useState({});
    const [errorMessage, setErrorMessage] = useState(null);
    const [selectedParentStoreName, setSelectedParentStoreName] = useState(null);
    const [selectedChildStoreNames, setSelectedChildStoreNames] = useState([]);
    const mouted = useRef();

    const query = new URLSearchParams(search);
   
    useEffect(() => {
        if(!mouted.current) {
            if(cookies.loginCookie?.data?.scope !== "admin") {
                setIsAllowAccessThisPage(false);
            }
            loadInitDatas();
            loadSetting();
            mouted.current = true;
        }
    }, []);
    // console.log("--- settingDatas:", settingDatas);
    const loadInitDatas = async() => {
        setIsLoading(true);
        const res = await httpClient.get(`/larksuite/init-datas`);
        if(!res.data.error) {
            setInitDatas(res.data.data);
            setIsLoading(false);
        } else {
            setErrorMessage("Lỗi:" + JSON.stringify(res.data?.error?.message));
            setIsLoading(false);
        }
    }

    const loadSetting = async() => {
        setIsLoading(true);
        const res = await httpClient.get(`/setting`);
        // console.log("--- loadSetting res:", res);
        if(!res.data.error) {
            setSettingDatas(res.data.data);
            setIsLoading(false);
        } else {
            setErrorMessage("Lỗi:" + JSON.stringify(res.data?.error?.message));
            setIsLoading(false);
        }
    }

    const handleMergeStores = async() => {
        // console.log("--- selectedParentStoreName:", selectedParentStoreName);
        // console.log("--- selectedChildStoreNames:", selectedChildStoreNames);
        const childStoreNames = selectedChildStoreNames.map(item => item.value);
        // console.log("--- childStoreNames:", childStoreNames);
        // Implement the logic to merge stores here
        if(!selectedChildStoreNames || selectedChildStoreNames.length === 0) {
            alert("Vui lòng chọn chi nhánh cần gom!");
            return;
        } else if(!selectedParentStoreName) {
            alert("Vui lòng chọn chi nhánh gốc!");
            return;
        } else if(childStoreNames.includes(selectedParentStoreName)) {
            alert("Chi nhánh gốc không thể nằm trong danh sách chi nhánh cần gom!");
            return;
        }

        confirmChoice("Bạn có đồng ý cập nhật dữ liệu?", async() => {
            setIsLoading(true);
            if(settingDatas?._id) {
                const settingUpdateRes = await httpClient.post(`/setting/update`, {
                    "_id": settingDatas._id,
                    "merge_store_revenue": [
                         ...settingDatas.merge_store_revenue,
                        {
                            "parentStoreName": selectedParentStoreName,
                            "childStoreNames": childStoreNames
                        }
                    ]
                });
                //console.log("--- handleMergeStores res:", settingUpdateRes);
                if(!settingUpdateRes.data.error) {
                    setSettingDatas(settingUpdateRes.data?.data);
                    setIsLoading(false);
                    toast({
                        title: "Lưu dữ liệu thành công!",
                        status: "success",
                        duration: 3000,
                        isClosable: true,
                    });
                } else {
                    setErrorMessage("Lỗi:" + JSON.stringify(settingUpdateRes.data?.error?.message));
                    setIsLoading(false);
                }
            } else {
                const settingAddRes = await httpClient.post(`/setting/add`, {
                    "merge_store_revenue": [
                        {
                            "parentStoreName": selectedParentStoreName,
                            "childStoreNames": childStoreNames
                        }
                    ]
                });
                //console.log("--- handleMergeStores res:", settingAddRes);
                if(!settingAddRes.data.error) {
                    setSettingDatas(settingAddRes.data?.data);
                    setIsLoading(false);
                    toast({
                        title: "Lưu dữ liệu thành công!",
                        status: "success",
                        duration: 3000,
                        isClosable: true,
                    });
                } else {
                    setErrorMessage("Lỗi:" + JSON.stringify(settingAddRes.data?.error?.message));
                    setIsLoading(false);
                }
            }
        })
    }

    const handleRemoveMergeStore = async (parentStoreName) => {
        confirmChoice("Bạn có muốn xoá không?", async() => {
            console.log("--- handleRemoveMergeStore parentStoreName:", parentStoreName);    
            const updatedMergeStoreRevenue = settingDatas?.["merge_store_revenue"]?.filter(item => item.parentStoreName !== parentStoreName);
            console.log("--- updatedMergeStoreRevenue:", updatedMergeStoreRevenue);

            const settingUpdateRes = await httpClient.post(`/setting/update`, {
                "_id": settingDatas?._id,
                "merge_store_revenue": updatedMergeStoreRevenue
            });
            if(!settingUpdateRes.data.error) {
                setSettingDatas(settingUpdateRes.data?.data);
                toast({
                    title: "Xoá dữ liệu thành công!",
                    status: "success",
                    duration: 3000,
                    isClosable: true,
                });
            } else {
                setErrorMessage("Lỗi:" + JSON.stringify(settingUpdateRes.data?.error?.message));
            }
        });
        
    }
    
    if(!isAllowAccessThisPage) {
        return (
            <Flex w="100%" p={4} flexDirection="column" alignItems="flex-start" justify="flex-start" h="100vh">
                <Text color="red.500"  fontSize="2xl" fontWeight="bold">**** Bạn không có quyền truy cập trang này (vui lòng liên hệ admin) ****</Text>
            </Flex>
        );
    }

    const SettingComponent = () => {
        return (
            <Flex flexDirection="column" gap={8}>
                <Heading size="md">Gom doanh thu về chi nhánh</Heading>
                <HStack spacing={4} align="stretch" gap={8}>
                    <HStack>
                        <Text>Chọn chi nhánh gốc:</Text>
                        <div>
                            <Select size="sm" value={selectedParentStoreName} placeholder="Chọn chi nhánh gốc"
                                onChange={
                                    (evt) => { setSelectedParentStoreName(evt.target.value) }
                                }
                            >
                                {
                                    initDatas?.["Fabi05"] &&
                                    ([...Object.keys(initDatas?.["Fabi05"]).sort((a, b) => a.localeCompare(b))] || []).map((key, idx) => (
                                        <option key={`original-store-name-${idx}`} value={key}>{key}</option>
                                    ))
                                }
                            </Select>
                        </div>                     
                    </HStack>
                    <HStack>
                        <Text>Chi nhánh cần gom:</Text>
                        <div style={{ minWidth: "200px" }}>
                            <MultiSelect 
                                options={
                                    initDatas?.["Fabi05"] &&
                                        ([...Object.keys(initDatas?.["Fabi05"]).sort((a, b) => a.localeCompare(b))] || []).map((key, idx) => (
                                            { label: key, value: key }
                                        )) || []
                                }   
                                value={selectedChildStoreNames}
                                onChange={setSelectedChildStoreNames}
                                labelledBy='Select'
                            />
                        </div>
                    </HStack>

                </HStack>
                <VStack align="flex-start" justify="flex-start">
                    <Text fontWeight="bold">Danh sách chi nhánh đã gom:</Text>
                    {
                        settingDatas?.merge_store_revenue?.length > 0 ?
                            settingDatas?.merge_store_revenue.map((item, idx) => (
                                <HStack key={`merge-store-revenue-${idx}`} align="start">
                                    <Text>{`${item?.parentStoreName}`}{` <---- ${item?.childStoreNames?.join(", ")}`}</Text>
                                    <Button size="sm" colorScheme="red"
                                        onClick={() => handleRemoveMergeStore(item?.parentStoreName)}
                                    >
                                        <Icon boxSize={6} as={MdDeleteForever} marginRight="8px"/> 
                                        Xóa
                                    </Button>
                                </HStack>
                            ))
                            :
                            (<Text>Chưa có dữ liệu</Text>)
                    }
                </VStack>
                <HStack spacing={4} align="stretch" gap={8} justify="flex-end">
                    <Button colorScheme="blue" onClick={() => handleMergeStores()}>Gom chi nhánh</Button>
                </HStack>
            </Flex>
        );
    }

    return (
        <Flex flexDirection="column" p={4} minHeight="100vh">
            <Flex flexDirection={{ base: "column", md: "row", lg: "row" }} justify="flex-start">
                <Flex flexDirection="column">
                    <Heading size="lg">Quản trị Admin</Heading>
                    <Tabs p={2}>
                        <TabList>
                            <Tab textTransform="uppercase">Tài khoản</Tab>
                            <Tab textTransform="uppercase">Cài đặt</Tab>
                        </TabList>
                        <TabPanels>
                            <TabPanel>
                                <Users />
                            </TabPanel>
                            <TabPanel>
                                <SettingComponent />
                            </TabPanel>
                        </TabPanels>
                    </Tabs>
                </Flex>
            </Flex>
        </Flex>
    )
}

export default Admin;